import React, { useState, useEffect } from 'react';
import Profile_Header from './Profile_Header';
import Footer from '../../Home_Page_WLog/Footer/Footer';
import { UserDataGetwt } from '../../Api/CoreApi';
import {BASE_API} from "../../Api/Api"

const UserHome = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterGender, setFilterGender] = useState('all');
    const [filterAge, setFilterAge] = useState('all');
    const [likedProfiles, setLikedProfiles] = useState(new Set());
    const [profiles, setProfiles] = useState([]);

    const toggleLike = (id) => {
        setLikedProfiles((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(id)) { newSet.delete(id); } else { newSet.add(id); }
            return newSet;
        });
    };

    useEffect(() => { loadProfiles(); }, []);

    const loadProfiles = async () => {
        try {
            const data = await UserDataGetwt();
            console.log("Profiles:", data);
            setProfiles(data);
        } catch (error) { console.log(error); }
    };

    // ✅ FIXED FILTER LOGIC — gender + age + search all work
    const filteredProfiles = profiles.filter((profile) => {
        const name = profile.firstname || "";
        const location = `${profile.city || ""} ${profile.state || ""}`;
        const age = parseInt(profile.age) || 0;

        // Search filter
        const matchesSearch =
            name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            location.toLowerCase().includes(searchTerm.toLowerCase());

        // Gender filter
        const matchesGender =
            filterGender === 'all' || profile.gender === filterGender;

        // Age filter
        let matchesAge = true;
        if (filterAge === '18-25') matchesAge = age >= 18 && age <= 25;
        else if (filterAge === '26-30') matchesAge = age >= 26 && age <= 30;
        else if (filterAge === '31-35') matchesAge = age >= 31 && age <= 35;
        else if (filterAge === '35+') matchesAge = age > 35;

        return matchesSearch && matchesGender && matchesAge;
    });

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
                *{font-family:'Poppins',sans-serif!important;box-sizing:border-box}

                @keyframes uhFloat{0%,100%{transform:translateY(0) rotate(0) scale(1)}50%{transform:translateY(-18px) rotate(6deg) scale(1.08)}}
                @keyframes uhBeat{0%,100%{transform:scale(1)}25%{transform:scale(1.15)}50%{transform:scale(1)}75%{transform:scale(1.15)}}
                @keyframes uhSlide{from{opacity:0;transform:translateY(25px)}to{opacity:1;transform:translateY(0)}}

                .uh-page{background:linear-gradient(180deg,#fff 0%,#fff5f7 50%,#fff 100%);min-height:100vh}

                /* Hero - Compact */
                .uh-hero{position:relative;padding:30px 20px;background:linear-gradient(135deg,#ff0044 0%,#ff3366 25%,#ff6699 55%,#ff99b5 78%,#ffc2d4 100%);overflow:hidden;text-align:center}
                .uh-hero::before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 20% 40%,rgba(255,255,255,.12),transparent 50%),radial-gradient(circle at 80% 20%,rgba(255,255,255,.08),transparent 45%);pointer-events:none}
                .uh-hero-float{position:absolute;opacity:.13;animation:uhFloat 6s ease-in-out infinite;pointer-events:none}
                .uh-hero-inner{position:relative;z-index:2;max-width:700px;margin:0 auto}
                .uh-hero-badge{display:inline-flex;align-items:center;gap:7px;padding:7px 16px;border-radius:999px;background:rgba(255,255,255,.18);backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.3);color:#fff;font-size:12px;font-weight:700;margin-bottom:14px}
                .uh-hero-title{font-size:clamp(24px,4.5vw,40px);font-weight:900;color:#fff;margin:0 0 10px;line-height:1.18}
                .uh-hero-accent{background:linear-gradient(90deg,#fff,#ffe4ec,#ffc2d4);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
                .uh-hero-sub{font-size:clamp(12px,1.8vw,15px);color:rgba(255,255,255,.9);max-width:500px;margin:0 auto 18px;line-height:1.7}
                .uh-hero-stats{display:flex;justify-content:center;gap:12px;flex-wrap:wrap}
                .uh-stat{display:flex;flex-direction:column;align-items:center;padding:10px 16px;min-width:95px;background:rgba(255,255,255,.14);backdrop-filter:blur(14px);border-radius:16px;border:1.5px solid rgba(255,255,255,.22);color:#fff;transition:all .3s ease}
                .uh-stat:hover{transform:translateY(-3px);background:rgba(255,255,255,.22)}
                .uh-stat-num{font-size:18px;font-weight:800}
                .uh-stat-label{font-size:10px;color:rgba(255,255,255,.82);font-weight:500;margin-top:2px}

                /* Filter */
                .uh-filter{max-width:1100px;margin:-24px auto 0;position:relative;z-index:10;padding:0 16px}
                .uh-filter-card{background:#fff;border-radius:22px;padding:18px 20px;box-shadow:0 14px 42px rgba(255,0,85,.09),0 0 0 1px rgba(255,0,85,.04);animation:uhSlide .5s ease}
                .uh-filter-top{display:flex;gap:10px;align-items:center;flex-wrap:wrap}
                .uh-search-box{flex:1;min-width:200px;position:relative}
                .uh-search-icon{position:absolute;left:12px;top:50%;transform:translateY(-50%);font-size:15px;color:#ff4d88}
                .uh-search-input{width:100%;height:44px;border-radius:12px;border:1.8px solid #f6bfd0;padding:0 12px 0 38px;font-size:13px;outline:none;transition:all .3s ease;background:#fff;box-shadow:0 2px 8px rgba(255,0,85,.03)}
                .uh-search-input:hover{border-color:#ff7ca8}
                .uh-search-input:focus{border-color:#ff0055;box-shadow:0 0 0 3px rgba(255,0,85,.10)}
                .uh-filter-selects{display:flex;gap:8px;flex-wrap:wrap}
                .uh-select{height:44px;border-radius:12px;border:1.8px solid #f6bfd0;padding:0 12px;font-size:12px;font-weight:600;color:#c2185b;background:#fff;outline:none;cursor:pointer;transition:all .3s ease;min-width:120px}
                .uh-select:hover{border-color:#ff7ca8}
                .uh-select:focus{border-color:#ff0055;box-shadow:0 0 0 3px rgba(255,0,85,.10)}
                .uh-result-count{text-align:center;margin-top:10px;font-size:12px;color:#888}
                .uh-result-count strong{color:#ff0055;font-weight:700}

                /* Grid */
                .uh-profiles{max-width:1200px;margin:0 auto;padding:32px 16px 50px}
                .uh-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:18px}

                /* Card - COMPACT */
                .uh-card{background:#fff;border-radius:20px;overflow:hidden;border:2px solid #ffe4ec;box-shadow:0 8px 24px rgba(255,0,85,.05);transition:all .38s cubic-bezier(.4,0,.2,1);animation:uhSlide .5s ease}
                .uh-card:hover{transform:translateY(-6px);border-color:#ff80aa;box-shadow:0 18px 44px rgba(255,0,85,.12)}

                .uh-card-img-box{position:relative;height:200px;overflow:hidden}
                .uh-card-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s ease}
                .uh-card:hover .uh-card-img{transform:scale(1.06)}
                .uh-card-fade{position:absolute;bottom:0;left:0;right:0;height:80px;background:linear-gradient(transparent,rgba(0,0,0,.4))}

                .uh-verified-tag{position:absolute;top:10px;left:10px;padding:4px 9px;border-radius:999px;background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;font-size:10px;font-weight:700;box-shadow:0 4px 10px rgba(255,0,85,.2)}
                .uh-like-btn{position:absolute;top:10px;right:10px;width:36px;height:36px;border-radius:50%;border:none;cursor:pointer;font-size:17px;display:flex;align-items:center;justify-content:center;transition:all .3s ease;box-shadow:0 4px 12px rgba(0,0,0,.1)}
                .uh-like-btn.not-liked{background:rgba(255,255,255,.88);backdrop-filter:blur(8px);color:#ff80aa}
                .uh-like-btn.liked{background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;animation:uhBeat .6s ease}
                .uh-like-btn:hover{transform:scale(1.1)}

                .uh-card-body{padding:14px 14px 14px}
                .uh-card-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}
                .uh-card-name{font-size:16px;font-weight:700;color:#1a0a10;margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:160px}
                .uh-card-age{padding:4px 9px;border-radius:999px;background:linear-gradient(135deg,#fff0f3,#ffe4ec);color:#ff0055;font-size:11px;font-weight:700;border:1px solid #ffd3df;white-space:nowrap}

                .uh-card-details{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:10px}
                .uh-detail{display:flex;align-items:center;gap:5px;font-size:11px;color:#777;padding:4px 8px;border-radius:8px;background:#fff8fa}
                .uh-detail-icon{font-size:12px}

                .uh-card-about{font-size:11.5px;color:#999;line-height:1.55;margin:0 0 12px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}

                .uh-card-actions{display:flex;gap:6px}
                .uh-btn-interest{flex:1;height:36px;border-radius:12px;border:none;background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;font-weight:700;font-size:12px;cursor:pointer;box-shadow:0 4px 14px rgba(255,0,85,.18);transition:all .3s ease}
                .uh-btn-interest:hover{transform:translateY(-1px);box-shadow:0 8px 20px rgba(255,0,85,.25)}
                .uh-btn-view{flex:1;height:36px;border-radius:12px;border:1.5px solid #ff0055;background:#fff;color:#ff0055;font-weight:700;font-size:12px;cursor:pointer;transition:all .3s ease;text-decoration:none;display:flex;align-items:center;justify-content:center}
                .uh-btn-view:hover{background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;border-color:#ff0055}

                /* Empty */
                .uh-empty{grid-column:1/-1;text-align:center;padding:50px 20px;background:linear-gradient(135deg,#fff,#fff5f7);border-radius:22px;border:2px solid #ffe4ec}
                .uh-empty-icon{font-size:48px;margin-bottom:12px;display:block;animation:uhBeat 2s infinite}
                .uh-empty h3{font-size:20px;font-weight:700;color:#c2185b;margin:0 0 6px}
                .uh-empty p{font-size:13px;color:#888;margin:0}

                /* Responsive */
                @media(max-width:768px){
                    .uh-hero{padding:24px 14px}
                    .uh-hero-stats{gap:8px}
                    .uh-stat{min-width:80px;padding:8px 12px}
                    .uh-filter{margin-top:-18px;padding:0 12px}
                    .uh-filter-card{padding:14px 14px}
                    .uh-filter-top{flex-direction:column}
                    .uh-filter-selects{width:100%}
                    .uh-select{flex:1}
                    .uh-grid{grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:14px}
                    .uh-card-img-box{height:180px}
                    .uh-profiles{padding:24px 12px 40px}
                }
                @media(max-width:480px){
                    .uh-grid{grid-template-columns:repeat(2,1fr);gap:12px}
                    .uh-card-img-box{height:160px}
                    .uh-card-body{padding:10px 10px 12px}
                    .uh-card-name{font-size:14px;max-width:110px}
                    .uh-card-age{font-size:10px;padding:3px 7px}
                    .uh-detail{font-size:10px;padding:3px 6px}
                    .uh-card-about{font-size:10.5px;-webkit-line-clamp:1}
                    .uh-btn-interest,.uh-btn-view{height:32px;font-size:11px;border-radius:10px}
                    .uh-card-actions{gap:5px}
                    .uh-like-btn{width:32px;height:32px;font-size:15px}
                    .uh-stat-num{font-size:15px}
                }
            `}</style>

            <Profile_Header />
            <div style={{ paddingTop: '70px' }}></div>

            <div className="uh-page">
                {/* Hero */}
                <section className="uh-hero">
                    {["💖","💍","💕","🌹","✨","❤️","🌸","💌"].map((e,i) => (
                        <span key={i} className="uh-hero-float" style={{
                            top:`${10+((i*8)%70)}%`, left:`${5+((i*11)%84)}%`,
                            fontSize:`${16+(i%4)*4}px`, animationDelay:`${i*0.4}s`
                        }}>{e}</span>
                    ))}
                    <div className="uh-hero-inner">
                        <div className="uh-hero-badge">💖 Trusted Matrimony</div>
                        <h1 className="uh-hero-title">Find Your <span className="uh-hero-accent">Perfect Match</span></h1>
                        <p className="uh-hero-sub">Connect with like-minded souls and start your beautiful journey together</p>
                        <div className="uh-hero-stats">
                            {[{num:"12K+",label:"Happy Couples"},{num:"50K+",label:"Active Members"},{num:"98%",label:"Success Rate"}].map((s,i) => (
                                <div key={i} className="uh-stat">
                                    <span className="uh-stat-num">{s.num}</span>
                                    <span className="uh-stat-label">{s.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Filter */}
                <section className="uh-filter">
                    <div className="uh-filter-card">
                        <div className="uh-filter-top">
                            <div className="uh-search-box">
                                <span className="uh-search-icon">🔍</span>
                                <input
                                    type="text"
                                    placeholder="Search by name or location..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="uh-search-input"
                                />
                            </div>
                            <div className="uh-filter-selects">
                                <select value={filterGender} onChange={(e) => setFilterGender(e.target.value)} className="uh-select">
                                    <option value="all">All Genders</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                                <select value={filterAge} onChange={(e) => setFilterAge(e.target.value)} className="uh-select">
                                    <option value="all">All Ages</option>
                                    <option value="18-25">18 – 25</option>
                                    <option value="26-30">26 – 30</option>
                                    <option value="31-35">31 – 35</option>
                                    <option value="35+">35+</option>
                                </select>
                            </div>
                        </div>
                        <div className="uh-result-count">
                            Showing <strong>{filteredProfiles.length}</strong> profiles
                        </div>
                    </div>
                </section>

                {/* Profiles */}
                <section className="uh-profiles">
                    <div className="uh-grid">
                        {filteredProfiles.length > 0 ? (
                            filteredProfiles.map((profile) => (
                                <div className="uh-card" key={profile.User_id || profile.id}>
                                    <div className="uh-card-img-box">
                                        <img
                                            src={`BASE_API${profile.pic}`}
                                            alt={profile.firstname}
                                            className="uh-card-img"
                                            loading="lazy"
                                            onError={(e) => { e.target.src = 'https://via.placeholder.com/300'; }}
                                        />
                                        <div className="uh-card-fade"></div>
                                        {profile.isVerified && <span className="uh-verified-tag">✅ Verified</span>}
                                        <button
                                            className={`uh-like-btn ${likedProfiles.has(profile.User_id || profile.id) ? 'liked' : 'not-liked'}`}
                                            onClick={() => toggleLike(profile.User_id || profile.id)}
                                        >
                                            {likedProfiles.has(profile.User_id || profile.id) ? '❤️' : '♡'}
                                        </button>
                                    </div>
                                    <div className="uh-card-body">
                                        <div className="uh-card-top">
                                            <h3 className="uh-card-name">{profile.firstname || 'Unknown'}</h3>
                                            <span className="uh-card-age">{profile.age || 'N/A'} yrs</span>
                                        </div>
                                        <div className="uh-card-details">
                                            <span className="uh-detail"><span className="uh-detail-icon">📍</span>{`${profile.city || ''} ${profile.state || ''}`.trim() || '—'}</span>
                                            <span className="uh-detail"><span className="uh-detail-icon">💼</span>{profile.job_title || '—'}</span>
                                            <span className="uh-detail"><span className="uh-detail-icon">🕉️</span>{profile.religion || '—'}</span>
                                        </div>
                                        <p className="uh-card-about">{profile.Lifestyle || 'No description.'}</p>
                                        <div className="uh-card-actions">
                                            <button className="uh-btn-interest">Send Interest</button>
                                            <button className="uh-btn-view" onClick={() => window.location.href = `/User_Data/${profile.User_id}`}>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="uh-empty">
                                <span className="uh-empty-icon">😔</span>
                                <h3>No profiles found</h3>
                                <p>Try adjusting your search or filters</p>
                            </div>
                        )}
                    </div>
                </section>
            </div>

            <Footer />
        </>
    );
};

export default UserHome;